import { environment } from '@/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { handleError } from '../tools/handle-error.tools';
import { CursosLogs } from '@/app/models/interface/cursos-logs.model';
import {
  PaginatorModel,
  HasPagination,
} from '@/app/models/interface/paginator.model';
import { CustomResponse } from '@/app/models/interface/response.model';

@Injectable({ providedIn: 'root' })
export class CursosLogsService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.socketApi + 'cursos';

  findAll(params: HttpParams) {
    return this.http
      .get<
        CustomResponse<PaginatorModel<CursosLogs[], HasPagination>>
      >(this.url, { params })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => data.result),
      );
  }
}
